<template>
    <resource-index title="Пользователи" endpoint="admin/users">
        <template slot="header-buttons">
            <router-link
                class="btn btn-secondary"
                :to="{
                    name: 'admin.users.create',
                }"
            >Создать</router-link>
        </template>

        <template v-slot:table-header>
            <tr class="border-b">
                <th class="text-left p-3 px-5" scope="col">Имя</th>
                <th class="text-left p-3 px-5" scope="col">Филиал</th>
                <th class="text-left p-3 px-5" scope="col">Роль</th>
                <th class="text-left p-3 px-5" scope="col">Баланс</th>
                <th class="text-left p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:table-filters="slotProps" v-if="selects.ready">
            <tr class="border-b">
                <th class="p-3 px-5" scope="col">
                    <text-field :wrap="false" v-model="slotProps.filters.name" />
                </th>

                <th class="p-3 px-5" scope="col">
                    <select-field
                        label="name"
                        valueName="id"
                        :wrap="false"
                        :options="selects.branches"
                        v-model="slotProps.filters.branch_id"
                    />
                </th>

                <th class="p-3 px-5" scope="col">
                    <select-field
                        label="title"
                        valueName="id"
                        :wrap="false"
                        :options="selects.roles"
                        v-model="slotProps.filters.role"
                    />
                </th>

                <th class="p-3 px-5" scope="col"></th>
                <th class="p-3 px-5" scope="col"></th>
            </tr>
        </template>

        <template v-slot:row="slotProps">
            <td class="p-3 px-5">{{ slotProps.entry.full_name }}</td>

            <td class="p-3 px-5">
                <span
                    class="badge whitespace-no-wrap badge-gray"
                    v-if="slotProps.entry.branch"
                >{{ slotProps.entry.branch.name }}</span>
            </td>

            <td class="p-3 px-5">
                <span
                    v-for="role in slotProps.entry.roles"
                    :key="role.id"
                    class="badge whitespace-no-wrap"
                    :class="'badge-' + role.color"
                >{{ role.title }}</span>
            </td>

            <td class="p-3 px-5">
                <span class="badge whitespace-no-wrap badge-success">{{ slotProps.entry.balance }} ₽</span>
            </td>

            <td class="p-3 px-5">
                <router-link
                    :to="{
                        name: 'admin.users.edit',
                        params: {
                            id: slotProps.entry.id
                        }
                    }"
                    class="btn btn-info"
                >Изменить</router-link>
            </td>
        </template>
    </resource-index>
</template>

<script>
import ResourceIndex from "@/components/Resource/ResourceIndex";

export default {
    components: {
        ResourceIndex
    },

    data() {
        return {
            selects: {
                ready: false,
                roles: [],
                branches: []
            }
        };
    },

    methods: {
        async fetchSelects() {
            await axios.get("/admin/roles/all").then(response => {
                this.selects.roles = response.data.data;
            });

            await axios.get("/admin/branches/all").then(response => {
                this.selects.branches = response.data.data;
            });

            this.selects.ready = true;
        }
    },

    mounted() {
        this.fetchSelects();
    }
};
</script>